import React from 'react';

export default function BtnPrimary({ text, href }) {
    return <a className="btn-secondary" href={href} >{text}</a>
}